import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import VerificationGate from "@/components/VerificationGate";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* One-time verification gate. Wraps App so that until the user
          has answered the gate's question correctly, App never mounts
          (no API calls, no effects, nothing). After a correct answer,
          a localStorage flag is set and App mounts as usual on this
          and all future visits. See components/VerificationGate.js. */}
      <VerificationGate>
        <App />
      </VerificationGate>
    </QueryClientProvider>
  </React.StrictMode>,
);
